import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Tab, Nav } from 'react-bootstrap';
// import './MyAccount.css';
import Swal from 'sweetalert2';
import BaseUrl from '../../ApiServices/BaseUrl';
import { FaEye, FaEyeSlash, FaUser, FaLock } from 'react-icons/fa';
import AdminNavbar from '../../Pages/Navbar/AdminNavbar';

function MyAccountAdmin() {
    const [activeTab, setActiveTab] = useState('profile');
    const [userId, setUserId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        mobile_number: '',
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
    });
    const [showPasswords, setShowPasswords] = useState({
        old: false,
        new: false,
        confirm: false
    });

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('user'));
        if (user && user.id) {
            setUserId(user.id);
            fetchUserData(user.id);
        } else {
            Swal.fire({
                title: 'Error!',
                text: 'No user found. Please login again.',
                icon: 'error',
                confirmButtonText: 'OK'
            }).then(() => {
                window.location.href = '/login';
            });
        }
    }, []);

    const fetchUserData = async (id) => {
        try {
            const response = await fetch(`${BaseUrl}/${id}`);
            if (!response.ok) {
                throw new Error('Failed to fetch user data');
            }
            const userData = await response.json();

            setFormData({
                name: `${userData.first_name} ${userData.last_name || ''}`,
                email: userData.email,
                mobile_number: userData.mobile_number,
                oldPassword: userData.password || '',
                newPassword: '',
                confirmPassword: ''
            });
            setLoading(false);
        } catch (error) {
            console.error('Error fetching user data:', error);
            Swal.fire({
                title: 'Error!',
                text: 'Failed to load user data',
                icon: 'error',
                confirmButtonText: 'OK'
            });
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const togglePassword = (field) => {
        setShowPasswords(prev => ({
            ...prev,
            [field]: !prev[field]
        }));
    };

    const handleUpdate = async (updatedPassword = null) => {
        try {
            const response = await fetch(`${BaseUrl}/${userId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: formData.email,
                    first_name: formData.name.split(' ')[0],
                    last_name: formData.name.split(' ')[1] || '',
                    mobile_number: formData.mobile_number,
                    password: updatedPassword || formData.oldPassword
                }),
            });

            if (!response.ok) {
                throw new Error('Update failed');
            }

            Swal.fire({
                title: 'Success!',
                text: 'Profile updated successfully!',
                icon: 'success',
                confirmButtonText: 'OK'
            });
        } catch (error) {
            console.error('Update error:', error);
            Swal.fire({
                title: 'Error!',
                text: 'Failed to update profile',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
    };

    const handlePasswordUpdate = () => {
        if (!formData.newPassword) {
            Swal.fire({
                title: 'Error!',
                text: 'Please enter a new password.',
                icon: 'error',
                confirmButtonText: 'OK'
            });
            return;
        }

        if (formData.newPassword !== formData.confirmPassword) {
            Swal.fire({
                title: 'Error!',
                text: 'Passwords do not match!',
                icon: 'error',
                confirmButtonText: 'OK'
            });
            return;
        }

        handleUpdate(formData.newPassword);

        // Reset password fields after update
        setFormData(prev => ({
            ...prev,
            newPassword: '',
            confirmPassword: ''
        }));
    };

    const [allowFreeChat, setAllowFreeChat] = useState(false);
    const [settingsLoading, setSettingsLoading] = useState(false);

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const res = await fetch(`${BaseUrl}/api/admin/settings/allow_free_custom_chat`);
                if (res.ok) {
                    const data = await res.json();
                    setAllowFreeChat(data.is_enabled === 1);
                }
            } catch (err) {
                console.error("Failed to load settings", err);
            }
        };
        fetchSettings();
    }, []);

    const handleToggleFreeChat = async () => {
        setSettingsLoading(true);
        try {
            const newState = !allowFreeChat;
            const res = await fetch(`${BaseUrl}/api/admin/settings/allow_free_custom_chat`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    setting_value: newState ? '1' : '0',
                    is_enabled: newState
                })
            });
            if (res.ok) {
                setAllowFreeChat(newState);
                Swal.fire({
                    title: 'Success!',
                    text: 'Chat settings updated successfully!',
                    icon: 'success',
                    timer: 1500,
                    showConfirmButton: false
                });
            } else {
                throw new Error("Failed to update");
            }
        } catch (err) {
            Swal.fire('Error', 'Failed to update settings', 'error');
        } finally {
            setSettingsLoading(false);
        }
    };

    if (loading) {
        return (
            <>
                <AdminNavbar />
                <Container className="py-4 card myaccount-card-body text-center">
                    <p>Loading user data...</p>
                </Container>
            </>
        );
    }

    return (
        <>
            <AdminNavbar />
            <div style={{ marginTop: '80px' }}>
                <Container className="profile-settings-container mt-4 mb-5">
                    <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
                        <Nav variant="tabs" className="custom-tabs justify-content-center mb-4">
                            <Nav.Item>
                                <Nav.Link eventKey="profile" style={{ width: '100%' }}>
                                    <FaUser /> Profile
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="password" style={{ width: '100%' }}>
                                    <FaLock /> Change Password
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="settings" style={{ width: '100%' }}>
                                    <i className="bi bi-gear-fill me-1"></i> Global Settings
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>

                        <Tab.Content>
                            <Tab.Pane eventKey="profile">
                                <Form>
                                    <Row className="mb-3">
                                        <Col md={6}>
                                            <Form.Group className="myaccount-form-group">
                                                <Form.Label className="myaccount-label">Name</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    value={formData.name}
                                                    name="name"
                                                    className="myaccount-input"
                                                    onChange={handleChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="myaccount-form-group">
                                                <Form.Label className="myaccount-label">Mobile No.</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    value={formData.mobile_number}
                                                    name="mobile_number"
                                                    className="myaccount-input"
                                                    onChange={handleChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Col md={12}>
                                            <Form.Group className="myaccount-form-group">
                                                <Form.Label className="myaccount-label">Email</Form.Label>
                                                <Form.Control
                                                    type="email"
                                                    value={formData.email}
                                                    name="email"
                                                    className="myaccount-input"
                                                    onChange={handleChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <div className="text-center" style={{ marginTop: '40px' }}>
                                        <button className="myaccountadmin-submit-button" style={{ backgroundColor: '#0080ff', color: 'white', border: '#0080ff', width: '125px', height: '40px', borderRadius: '0px' }} onClick={() => handleUpdate()}>
                                            UPDATE
                                        </button>
                                    </div>
                                </Form>
                            </Tab.Pane>

                            <Tab.Pane eventKey="password">
                                <Form>
                                    <div className="text-center mb-4">
                                        <img src="https://cdn-icons-png.flaticon.com/512/3064/3064197.png" width="80" alt="lock" />
                                    </div>

                                    <Form.Group className="mb-3 position-relative">
                                        <Form.Label className="myaccount-label">Old Password</Form.Label>
                                        <Form.Control
                                            type={showPasswords.old ? "text" : "password"}
                                            name="oldPassword"
                                            value={formData.oldPassword}
                                            onChange={handleChange}
                                            className="myaccount-input"
                                            placeholder="Old Password"
                                            readOnly
                                        />
                                        <span
                                            className="position-absolute"
                                            onClick={() => togglePassword('old')}
                                            style={{ top: '38px', right: '10px', cursor: 'pointer' }}
                                        >
                                            {showPasswords.old ? <FaEyeSlash /> : <FaEye />}
                                        </span>
                                        <small className="text-primary d-block mt-1">
                                            You have signed up using Social Login and so no need to add old password
                                            but you can set a new password.
                                        </small>
                                    </Form.Group>

                                    <Form.Group className="mb-3 position-relative">
                                        <Form.Label className="myaccount-label">New Password</Form.Label>
                                        <Form.Control
                                            type={showPasswords.new ? "text" : "password"}
                                            name="newPassword"
                                            value={formData.newPassword}
                                            onChange={handleChange}
                                            className="myaccount-input"
                                            placeholder="New Password"
                                        />
                                        <span
                                            className="position-absolute"
                                            onClick={() => togglePassword('new')}
                                            style={{ top: '38px', right: '10px', cursor: 'pointer' }}
                                        >
                                            {showPasswords.new ? <FaEyeSlash /> : <FaEye />}
                                        </span>
                                    </Form.Group>

                                    <Form.Group className="mb-4 position-relative">
                                        <Form.Label className="myaccount-label">Confirm Password</Form.Label>
                                        <Form.Control
                                            type={showPasswords.confirm ? "text" : "password"}
                                            name="confirmPassword"
                                            value={formData.confirmPassword}
                                            onChange={handleChange}
                                            className="myaccount-input"
                                            placeholder="Confirm Password"
                                        />
                                        <span
                                            className="position-absolute"
                                            onClick={() => togglePassword('confirm')}
                                            style={{ top: '38px', right: '10px', cursor: 'pointer' }}
                                        >
                                            {showPasswords.confirm ? <FaEyeSlash /> : <FaEye />}
                                        </span>
                                    </Form.Group>

                                    <div className="text-center">
                                        <button className="myaccount-submit-btn" onClick={handlePasswordUpdate}>
                                            Change Password
                                        </button>
                                    </div>
                                </Form>
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </Container>
            </div>
        </>
    );
}

export default MyAccountAdmin;
